import {SERVER_CDN_PATH} from "../constants";
import React from "react";

export const isDesktop = () => {
    const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return clientWidth > 767;
};

export const isValidDate = (day, month, year) => {
    const d = new Date(year, month - 1, day);
    return d.getFullYear() === parseInt(year) && d.getMonth() + 1 === parseInt(month) && d.getDate() === parseInt(day);
}

export const calculateAge = (day, month, year) => {
    const today = new Date();
    const birthDate = new Date(year, month - 1, day);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    const d = today.getDay() - birthDate.getDay();

    if (age === 0 && (m > 0 || (m === 0 && d >= 0))) {
        age = 1;
    } else if (age === 18 && (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))) {
        age -= 1;
    } else if (age === 100 && (m > 0 || (m === 0 && today.getDate() > birthDate.getDate()))) {
        age += 1;
    }

    return age;
};

export const invalidateBtagCookie = () => {
    document.cookie = `btag=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.bet9ja.com;path=/`;
};

export const invalidatePromocodeCookie = () => {
    document.cookie = `promocode=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.bet9ja.com;path=/`;
};

export function getYears() {
    const years = [];
    const thisYear = new Date().getFullYear();
    for (let i = thisYear - 18; i > thisYear - 100; i -= 1) {
        years.push(i);
    }
    return years;
}

export const isNotEmptyString = text => (text && text !== '');

export const showLoader = () => {
    return (
        <span style={{marginRight: '5px'}}>
            <img src={`/${SERVER_CDN_PATH}/img/loading.gif`} alt="spinner"/>
        </span>
    );
}